import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import CalculationsPageUI from './CalculationsPageUI.js'

class CalculationsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      subservientMCA: null,
      subservientITR: null,
      chargeValueMCA: null,
      chargeValueITR: null,
      editable: false,
      details: false
    }
  }

  render() {
    return (
      <CalculationsPageUI
        context={this.props.context}
        account={this.state.account}
        subservientMCA={this.state.subservientMCA}
        subservientITR={this.state.subservientITR}
        chargeValueMCA={this.state.chargeValueMCA}
        chargeValueITR={this.state.chargeValueITR}
        toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
        editable={this.state.editable}
        onDetailsClick={() => { this.setState({ details: !this.state.details }) }}
        details={this.state.details}
        onShowDetailsClick={() => { this.setState({ showDetails: !this.state.showDetails }) }}
        showDetails={this.state.showDetails}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getSubservientMCA(context)
    this.getSubservientITR(context)
    this.getChargeValueMCA(context)
    this.getChargeValueITR(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getSubservientMCA(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/mca/subservientCharge`,
      cacheKey: CacheKeys.SubservientMCA(this.props.match.params.accountId),
      callback: this.getSubservientMCACallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getSubservientMCACallback = (response) => {
    this.setState({
      subservientMCA: response
    })
  }

  getSubservientITR(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/itr/subservientCharge`,
      cacheKey: CacheKeys.SubservientITR(this.props.match.params.accountId),
      callback: this.getSubservientITRCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getSubservientITRCallback = (response) => {
    this.setState({
      subservientITR: response
    })
  }

  getChargeValueMCA(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/mca/chargeValue`,
      cacheKey: CacheKeys.ChargeValueMCA(this.props.match.params.accountId),
      callback: this.getChargeValueMCACallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getChargeValueMCACallback = (response) => {
    this.setState({
      chargeValueMCA: response
    })
  }

  getChargeValueITR(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/itr/chargeValue`,
      cacheKey: CacheKeys.ChargeValueITR(this.props.match.params.accountId),
      callback: this.getChargeValueITRCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getChargeValueITRCallback = (response) => {
    this.setState({
      chargeValueITR: response
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.SubservientITR(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.SubservientMCA(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.ChargeValueITR(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.ChargeValueMCA(this.props.match.params.accountId))
    this.setState({ subservientMCA: null, subservientITR: null, chargeValueMCA: null, chargeValueITR: null },
      this.getSubservientMCA(context),
      this.getSubservientITR(context),
      this.getChargeValueMCA(context),
      this.getChargeValueITR(context)
    )
  }
}

export default withRouter(CalculationsPageSF)
